export const toBoolean = (val) => val === true || val === 'true';
